// extracted by mini-css-extract-plugin
module.exports = {"root":"ShareModal_root__1fGl7","title":"ShareModal_title__4AsZr","linkInput":"ShareModal_linkInput__HGmLc","link":"ShareModal_link__3qdQ8"};